export function InkHeading() {
  const text = "Karim Siala";

  return (
    <h1
      aria-label={text}
      className="text-[clamp(1.6rem,3.6vw,2.4rem)] mb-[18px] font-normal caps-title"
    >
      {Array.from(text, (char, i) => (
        <span
          key={i}
          aria-hidden="true"
          className="inline-block whitespace-pre animate-[ink-in_900ms_ease-out_both]"
          style={{ animationDelay: `${500 + i * 90}ms` }}
        >
          {char}
        </span>
      ))}
    </h1>
  );
}
